import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logD } from "@blacknut/logging/dist";
import {
  getEntitlements,
  NotificationType,
  RemoteNotificationTrigger,
} from "@blacknut/javascript-sdk/dist";
import {
  NotificationMessage,
  NotificationMessageKind,
  State,
  UserActionTypes,
  addNotification,
  getSubscription,
  notificationService,
} from "core";
import { firstValueFrom } from "rxjs";

const LOGGING_TAG = "useSubscribeNotifications";

export const useSubscribeNotifications = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: State) => state.globalState.user);

  useEffect(() => {
    notificationService.onReconnect().subscribe(async () => {
      // Did we miss something?
      try {
        const entitlements = await firstValueFrom(getEntitlements());
        dispatch({
          type: UserActionTypes.FETCH_ENTITLEMENTS_SUCCESS,
          entitlements,
        });
      } catch (e) {}
    });

    const sub = notificationService.onMessage().subscribe((n: NotificationMessage) => {
      if (n.kind !== NotificationMessageKind.NOTIFICATION_RESP) return;
      const { notification } = n.payload as any;

      if (notification.trigger === RemoteNotificationTrigger.PLAN_SUBSCRIBED) {
        logD(LOGGING_TAG, "Received plan subscribed notification: %o", notification);
        dispatch(getSubscription());
        addNotification({
          type: NotificationType.SUCCESS,
          time: new Date().getTime(),
          message: "notifications.subscriptionupdated",
        })(dispatch);
      }
      if (notification.trigger === RemoteNotificationTrigger.UBISOFT_CONNECT) {
        logD(LOGGING_TAG, "Received ubisoft connect notification: %o", notification);
        if (notification.status === "success") {
          dispatch(getSubscription());
          addNotification(
            {
              type: NotificationType.SUCCESS,
              time: new Date().getTime(),
              message: "notifications.ubisoftconnect.success",
            },
            8000,
          )(dispatch);
        }
      }
    });
    return () => {
      sub.unsubscribe();
    };
  }, [dispatch, user]);
};
